module.exports = __webpack_public_path__ + "static/media/diners.fa6db1cf.png";